import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { track } from 's2s-app-service';
import { injectIntl } from 'react-intl';

import ZeroUserControls from './zeroState';
import DialingUserControls from './dialing';
import ActiveUserControls from './active';
import IntiateTransferUserControls from './initiateTransfer';
import AttendedTransferUserControls from './attendedTransfer';

import AudioControls from '../audioControls';
import useCallInfo from "../../hooks/callInfo";
import useSettings from "../../hooks/settings";

const Container = styled.div`

`;


const UserControls = injectIntl((props) => {
  const [callInfo, { holdCall }] = useCallInfo();
  const [settings, { changeSettings }] = useSettings();
  const [showAudioControls, setShowAudioControls] = useState(false);
  const [showDTMFKeypad, setShowDTMFKeypad] = useState(false);
  const [dialingInputValue, setDialingInputValue] = useState("");

  // console.warn('@@@@@@@@@@@@@@@@@ userControls render', props);

  const handleKeyPress = (e) => {
    // Enter pressed, so make call with number currently in dialInput
    if (e.nativeEvent.keyCode === 13) {
      handleMakeCall();
    }
  };

  const handleMakeCall = (action, data, e) => {
    // console.log('handleMakeCall', action, data, e, props.cbUserAction);
    // get the value from the dialInput.  If it is not set, then set it to the lastNumber.
    const numberToDial = dialingInputValue;

    if (numberToDial && numberToDial.length > 0) {
      props.setShowAddCallKeypad(false);
      // console.log("handling make call", numberToDial);
      props.cbUserAction('make-call', numberToDial, e);
    } else {
      if (callInfo.lastNumber.length > 0) {
        setDialingInputValue(callInfo.lastNumber);
      } else {
        //console.warn("no last number");
      }
    }
  };

  const handleCallClick = (e) => {
    // since may have been adding a new call and showing the AddCallKeypad, set show to false
    track("make_call", "clicked");
    props.setShowAddCallKeypad(false);
    handleMakeCall('make-call', undefined, e);
  };

  const cancelDTMFOnClick = (/* e */) => {
    //props.cbUserAction('cancelDTMF');
    setShowDTMFKeypad(false);
  };

  const hangupCancelDTMFOnClick = (e) => {
    setShowDTMFKeypad(false);
    //props.cbUserAction('hangup');
    props.cbUserAction("hangup", callInfo.activeCallId, e);
  };

  const handleCancelAddCallClick = (e) => {
    props.setShowAddCallKeypad(false);
    props.cbUserAction('cancelAddCall', undefined, e);
  };

  const handleCallControlActionClick = (key, param, event) => {
    track("call_control", "clicked", key);
    //console.log("key, param", key, param, event);

    switch (key) {
      case 'hangup':
        // console.warn("TODO do hangup --- here also");
        props.cbUserAction("hangup", callInfo.activeCallId, event);
        break;
      case 'keypad':
        setShowDTMFKeypad(true);
        break;
      case 'audio':
        setShowAudioControls(true);
        props.cbUserAction(key, param);
        break;

      case 'new_call':
        if (callInfo.activeCallId && callInfo.inprogressCalls[callInfo.activeCallId] && !callInfo.inprogressCalls[callInfo.activeCallId].isHeld) {
          holdCall(callInfo.activeCallId, props.intl);
        }

        props.setShowAddCallKeypad(true);
        break;

      case 'merge': 
        props.cbUserAction("merge", callInfo, event);
        break;  

      default:
        props.cbUserAction(key, param);
    }
  };

  const handleCancelTransferClick = (e) => {
    props.cbUserAction('cancelTransfer', undefined, e);
  };

  const handleBlindTransferClick = (e) => {
    const numberToDial = dialingInputValue;
    if (numberToDial) {
      props.cbUserAction('blindTransfer', { callId: callInfo.activeCallId, transferToNbr: numberToDial }, e);
    }
  };

  const handleAttendedTransferClick = (e) => {
    const numberToDial = dialingInputValue;
    if (numberToDial) {
      props.cbUserAction('attendedTransfer', { callId: callInfo.activeCallId, transferToNbr: numberToDial }, e);
    }
  };

  const handleAudioControlsClick = (actionType, newSettings) => {
    switch (actionType) {
      case "cancel":
        setShowAudioControls(false);
        break;
      case "audioSave":
        changeSettings(newSettings, props.intl);
        setShowAudioControls(false);
        break;
      default:
        console.log("No action type argument for handleAudioControlsClick");
    }
  };

  // DialingInput BackspaceIconSVG clicked
  const handleBackspaceClick = (value) => {
    // Clicking the BackspaceIconSVG will always delete the last character. 
    // This is the same behavior as previous versions - KCN
    const newValue = value.slice(0, value.length - 1);
    setDialingInputValue(newValue);
  };

  // Typing within DialingInput
  const handleDialingInputChange = (value) => {
    // The value coming in from input change event is the complete value. No need to concat. 
    // console.log('dialinput val....', value, dialingInputValue);
    setDialingInputValue(value);
  };

  // KeypadItem clicked
  const handleKeypadClick = (value) => {
    // console.log('keypad pressed', value);
    //eslint-disable-next-line no-undef
    // console.log('dial input value', window._GLOBAL_DIALING_INPUT_VALUE, '>>>>>', dialingInputValue);
    if (showDTMFKeypad) {
      props.cbUserAction('dtmf-dial', value);
    } else {
      setDialingInputValue(dialingInputValue => dialingInputValue + value);
    }
  };

  const renderAudioControlsArea = () => {
    // let outputDevices = settings && settings.outputAudio && settings.outputAudio.map((device) => {
    //   return {
    //     label: device.label,
    //     value: device.deviceId
    //   };
    // });
    return (
      <AudioControls
        activeCallId={callInfo.activeCallId}
        cbOnClick={handleAudioControlsClick}
        selectedOutputDevice={settings.selectedSpeaker}
      />);
  };

  const renderUserControlsArea = () => {
    let userControlsJSX;

    switch (props.userControlStatus) {
      default:
      case "zero":
        userControlsJSX = (
          <ZeroUserControls
            className="zeroUserControls"
            {...props}
            cbHandleKeyPress={handleKeyPress}
            cbHandleBackspaceClick={handleBackspaceClick}
            cbHandleDialingInputChange={handleDialingInputChange}
            dialingInputValue={dialingInputValue}
            cbHandleKeypadClick={handleKeypadClick}
            cbHandleCallClick={handleCallClick}
            userControlStatus={props.userControlStatus}
            dtmfOutputDeviceId={settings && settings.selectedSpeaker && settings.selectedSpeaker.value ? settings.selectedSpeaker.value : undefined}
          />
        );
        break;

      case "dialing":
        userControlsJSX = (
          <DialingUserControls
            className="dialingUserControls"
            {...props}
            cbCancelDTMFOnClick={cancelDTMFOnClick}
            cbHangupCancelDTMFOnClick={hangupCancelDTMFOnClick}
            cbHandleCallControlActionClick={handleCallControlActionClick}
            cbHandleKeypadClick={handleKeypadClick}
            showDTMFKeypad={showDTMFKeypad}
            dtmfOutputDeviceId={settings && settings.selectedSpeaker && settings.selectedSpeaker.value ? settings.selectedSpeaker.value : undefined}
          />
        );
        break;

      case "active":
        // console.warn('ACTIVE call props.showAddCallKeypad', props.showAddCallKeypad);
        userControlsJSX = (
          <ActiveUserControls
            className="activeUserControls"
            {...props}
            cbHandleKeyPress={handleKeyPress}
            cbHandleBackspaceClick={handleBackspaceClick}
            cbHandleDialingInputChange={handleDialingInputChange}
            dialingInputValue={dialingInputValue}
            cbHandleKeypadClick={handleKeypadClick}
            cbHandleCallClick={handleCallClick}
            cbCancelDTMFOnClick={cancelDTMFOnClick}
            cbHangupCancelDTMFOnClick={hangupCancelDTMFOnClick}
            cbHandleCallControlActionClick={handleCallControlActionClick}
            cbHandleCancelAddCallClick={handleCancelAddCallClick}
            showDTMFKeypad={showDTMFKeypad}
            showAddCallKeypad={props.showAddCallKeypad}
            showMergingCallKeypad={true}
            dtmfOutputDeviceId={settings && settings.selectedSpeaker && settings.selectedSpeaker.value ? settings.selectedSpeaker.value : undefined}
            theme={props.theme}
          />
        );
        break;

      case "initiateTransfer":
        userControlsJSX = (
          <IntiateTransferUserControls
            {...props}
            cbHandleKeyPress={handleKeyPress}
            cbHandleBackspaceClick={handleBackspaceClick}
            cbHandleDialingInputChange={handleDialingInputChange}
            dialingInputValue={dialingInputValue}
            cbHandleKeypadClick={handleKeypadClick}
            inprogressCalls={callInfo}
            cbHandleCancelTransferClick={handleCancelTransferClick}
            cbHandleBlindTransferClick={handleBlindTransferClick}
            cbHandleAttendedTransferClick={handleAttendedTransferClick}
            dtmfOutputDeviceId={settings && settings.selectedSpeaker && settings.selectedSpeaker.value ? settings.selectedSpeaker.value : undefined}
          />
        );
        break;
      case "attendedTransfer":
        userControlsJSX = (
          <AttendedTransferUserControls
            {...props}
            cbCancelDTMFOnClick={cancelDTMFOnClick}
            cbHandleKeypadClick={handleKeypadClick}
            cbHangupCancelDTMFOnClick={hangupCancelDTMFOnClick}
            cbHandleCallControlActionClick={handleCallControlActionClick}
          />
        );
        break;
    }
    return userControlsJSX;
  };

  // console.log('DIALING INPUT VALUE', dialingInputValue);
  return (
    <Container
      className="UserControlsContainer"
    >
      {showAudioControls ? renderAudioControlsArea() : renderUserControlsArea()}
    </Container>
  );
});

UserControls.propTypes = {
  cbUserAction: PropTypes.func,
  userControlStatus: PropTypes.string,
  intl: PropTypes.object,
  showAddCallKeypad: PropTypes.bool,
  setShowAddCallKeypad: PropTypes.func
};

UserControls.defaultProps = {
  cbUserAction: () => { },
  userControlStatus: "zero"
};

export default injectIntl(UserControls);
